import React, { Component } from 'react'
import Axios from 'axios';
import { Spin, Icon, Result, Alert } from 'antd';
import { Element, scroller } from "react-scroll"


export default class Forms extends Component {
    
    constructor(props){
        super(props);
        // this.resultRef = React.createRef();
        this.refrence = React.createRef();
        this.state = {
            response : {},
            message: null,
            gotResponse: false,
            registering: false,
            registered: false,
            selectedEvent: null
        }

    }

    componentDidUpdate(){
        if(this.state.gotResponse){
            scroller.scrollTo('sub1', {
                duration: 500,
                smooth: true,
                offset: -50, 
            })
        }
    }
    

    register = e => {
        this.setState({
            registering : true,
            registered : false,
            gotResponse : false 
        });
        e.preventDefault();
        let phone = document.getElementById("phonex");
        let event = document.getElementById("eventx");
        var data = new FormData();
        data.append("phone",phone.value);
        data.append("event",event.value);
        data.append("check","yes");
        

        // console.log(data);
        Axios.post("https://script.google.com/macros/s/AKfycbwvjIgjDla5JCFwpEVKLdWcadViUl2b9hxiCUTbeWx-HOHll8zy/exec",data)
        .then(res => {
            console.log(res.data)
            var responseData = res.data;
            if(responseData.ERROR){
                this.setState(
                    {
                        error: "SOMETHING WENT WRONG!"
                    }
                )
            }
            else{
                this.setState({
                    message: responseData,
                    registering: false,
                    registered: true
                })
            }
        })
        .catch(res =>{
            console.log(res)
        })
        this.setState({
            gotResponse: true
        })
        console.log(this.state)
    }

    eventselected = e => {
        // console.log(e.target.value);
        this.setState({
            selectedEvent: e.target.value,
            registering : false,
            registered : false,
            gotResponse : false 
        })
    }

    
        // console.log();
    

    render() {
        var classname = "";
        var submitbuttondata = "";
        var resullt = "";
        if(this.state.registering){
            const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
            submitbuttondata = <Spin indicator={antIcon}/>
            classname = "btn btn-lg btn-white btn-icon mb-3 mb-sm-0";
        }
        else{
            submitbuttondata = 'CHECK'
            classname = "btn btn-lg btn-primary btn-icon mb-3 mb-sm-0";
            if(this.state.registered){
                if(this.state.message.isValid != false){
                    // console.log(this.state.message.error)
                    resullt = <Result
                                        icon={<Icon type="smile" theme="twoTone" />}
                                        title={this.state.message.isValid}
                                    />
                }
                else{
                    let errorsR = this.state.message.isValid.toString();
                    // errorsR.pop();
                    // const listItems = errorsR.map((e) =>
                    //     <Alert key={e.toString()} message={e} type="error"/>
                    // );
                    // console.log("ls:"+listItems);
                    resullt = <Result
                                    status="warning"
                                    title="Error."
                                    extra={
                                        <h3>
                                            NOT YET REGISTERED! GO ON FILL UP THE FORM...
                                        </h3>
                                    }
                                />
                }
            }
        }

        var single =
                <> 
                <div className="offset-md-2 col-md-8">
                    <h5>Contact Number:</h5>
                <Element name="sub1" className="element" >
                    <input required pattern="\d{10}" title="10 digits" className="form-control mb-3" id="phonex" style={{color:'black'}} placeholder="Your Mo. No."/>
                </Element>
                </div>
                <div className="offset-md-2 col-md-8" style={{textAlign:'center'}}>
                    <button id='submitx' className={classname} ref={this.refrence} style={{width: '200px',borderRadius: '25px'}}>
                        <span className="btn-inner--text">{submitbuttondata}</span>
                    </button>
                    {resullt}
                    
                </div>
                </>


        

        if(this.state.selectedEvent === "itquiz" 
            || this.state.selectedEvent === "cquiz"
            || this.state.selectedEvent === "pyit"
            || this.state.selectedEvent === "pucket"
            || this.state.selectedEvent === "bounce"
            || this.state.selectedEvent === "shoot"
            || this.state.selectedEvent === "roll"
            ){
            var forminput = single;
        } else if (
            this.state.selectedEvent === "wysiwyg" 
            || this.state.selectedEvent === "relaycoding"
            || this.state.selectedEvent === "imageit"
            || this.state.selectedEvent === "auction"
            || this.state.selectedEvent === "ulzhan"
        ){
            var forminput = single;
        } else if(
            this.state.selectedEvent === "mini"
        ){
            var forminput = single;
        }



        return (
            <>
    <hr/>
        <h2 style={{textAlign:'center'}}>CHECK REGISTRATION HERE</h2>
        <form id="regdata" style={{padding:'25px',margin:'25px'}} onSubmit={this.register}>
            <div className="row align-items-center">
              

                <div className="col-md-8 ml-auto mr-auto">
                      <h5>Event:</h5>
                      <select className="form-control mb-3" id="eventx" placeholder="select event" onChange={this.eventselected} style={{color:'black'}}>
                            <option value="" disabled selected>Select Event</option>
                            <option disabled style={{fontWeight: "bold"}}>TECHNICAL EVENTS</option>
                            <option value="itquiz">IT Quiz</option>
                            <option value="wysiwyg">WYSIWYG</option>
                            <option value="pyit">PYIT</option>
                            <option value="imageit">Image IT</option>
                            <option value="relaycoding">Relay Coding</option>
                            <option value="cquiz">C Quiz</option>
                            {/* <option disabled></option> */}
                            <option disabled style={{fontWeight: "bold"}}>NON TECHNICAL EVENTS</option>
                            <option value="mini">Mini Militia</option>
                            <option value="auction">Auction Pitch</option>
                            <option value="pucket">Pucket</option>
                            <option value="bounce">Bounce Perfect</option>
                            <option value="roll">Roll The Dice</option>
                            <option value="shoot">Shoot the Bottle Cap</option>
                            <option value="ulzhan">Ulzhan Sulzhan</option>
                      </select>
                </div>
                {/* <div className="offset-md-2 col-md-8">
                      <h5>Event:</h5>
                      <input type="text" className="form-control mb-3" id="event" style={{color:'black'}} placeholder="Event"/>
                    </div> */}
                {
                    forminput
                }
                
            </div>
        </form>
                    {/* <hr/>
                <div className="container">
                    <center><h3>Proud Sponsor</h3></center>
                    <div className="row">
                        <div className="col-sm-12 col-md-10 col-lg-4 ml-auto mr-auto">
                            <img style={{width:"100%"}} src="eventposters/sponsor.PNG" />
                        </div>
                    </div>
                </div> */}


           
        </>
        )


    }
}
